var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('el-card',[_c('h1',[_vm._v(_vm._s(this.$route.name))]),_c('Table',{attrs:{"border":true,"stripe":"","tableData":_vm.tableData,"column":_vm.tableColumn,"max-height":_vm.clientHeight * 0.8}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }